<template>
  <div :style="{ margin: margin}">
    <router-link
      :to="link"
    >
      <el-button
        size="small"
        icon="fas fa-arrow-left"
      >
        {{ text }}
      </el-button>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'back-link',
  props: {
    text: {type: String, default: 'Вернуться'},
    link: {type: Object},
    margin: {type: String, default: '0'},
  },
}
</script>

<style>

</style>
